module.exports = __webpack_public_path__ + "img/default-avatar.5e4f3c16.png";